import { render, staticRenderFns } from "./ProductEditing.vue?vue&type=template&id=06757924&scoped=true"
import script from "./ProductEditing.vue?vue&type=script&lang=js"
export * from "./ProductEditing.vue?vue&type=script&lang=js"
import style0 from "./ProductEditing.vue?vue&type=style&index=0&id=06757924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06757924",
  null
  
)

export default component.exports